import { VetologyBase } from '../Vetology/VetologyBase'

export class CountrySelector extends VetologyBase
{
    constructor()
    {
        super('CountrySelector');
    }


    init ()
    {
        const _self = this;
	    _self.initEventHandlers();

        let countryCodes = document.body.dataset.country_codes;
        if (countryCodes) {
            countryCodes = JSON.parse(countryCodes);
            if (typeof countryCodes === 'object') {
                const countryElement = document.querySelector('select[name="resp_country_id"]');
                if (countryElement) {
                    const countryOptions = countryElement.querySelectorAll('option');
                    countryOptions.forEach((option) => {
                        option.dataset.country_code = countryCodes[option.value];
                    });
                }
            }
        }
    }

    initEventHandlers ()
    {
        const _self = this;

        const countryElement = document.querySelector('select[name="resp_country_id"]');
        _self.onCountryInput = _self.onCountryInput.bind(_self);
        if (countryElement) {
            countryElement.addEventListener('input', _self.onCountryInput);
        }
    }

	removeEventHandlers()
	{
		const _self = this;

		const countryElement = document.querySelector('select[name="resp_country_id"]');
		if (countryElement) {
			countryElement.removeEventListener('input', _self.onCountryInput);
		}

	}

    onCountryInput (event)
    {
        const _self = this;
        const countrySelector = event.target;

        const selectedOption = countrySelector.querySelector('option:checked');
        const countryCode = selectedOption.dataset.country_code;
        if (countryCode > 0) {
            const respPersonPhoneCountryCodeSelector = document.querySelector('select[name="country_code_RespPersonPhone"]');
            const respPersonCellCountryCodeSelector = document.querySelector('select[name="country_code_RespPersonCell"]');
            const respOrgPhoneCountryCodeSelector = document.querySelector('select[name="country_code_RespOrgPhone"]');

            if (respPersonPhoneCountryCodeSelector) {
                respPersonPhoneCountryCodeSelector.value = countryCode;
            }
            if (respPersonCellCountryCodeSelector) {
                respPersonCellCountryCodeSelector.value = countryCode;
            }
            if (respOrgPhoneCountryCodeSelector) {
                respOrgPhoneCountryCodeSelector.value = countryCode;
            }
        }

    }
}
